import React, { useState } from "react";
import {
  Modal,
  Form,
  Row,
  Col,
  Input,
  Select,
  DatePicker,
  InputNumber,
} from "antd";
import { eContent } from "../../constant/field-names";
import {
  StyledButton,
  StyledTitle,
} from "../../../../../../components/styled-antd";

export const CreateModal = ({ dataSource, setDataSource }: any) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [form] = Form.useForm();

  const showModal = () => {
    form.resetFields();
    setIsModalOpen(true);
  };
  const handleOk = async () => {
    // const validate = await form.validateFields();
    const values = form.getFieldsValue();

    setDataSource([...dataSource, values]);
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    form.resetFields();
    setIsModalOpen(false);
  };
  return (
    <>
      <StyledButton bgColor="yellow" onClick={showModal} className="mb-3">
        <div className="pb-1">Thêm mới</div>
      </StyledButton>

      <Modal
        title="THÊM SẢN PHẨM CẦN XUẤT KHO"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
        width={"70%"}
      >
        <Form form={form}>
          <Row gutter={[32, 0]}>
            <Col span={24}>
              <StyledTitle level={5}>
                Tên vật tư/ hàng hóa <span className="text-danger">(*)</span>
              </StyledTitle>
              <Form.Item
                name={eContent.productName}
                rules={[
                  { required: true, message: "Nhập tên vật tư/ hàng hóa *" },
                ]}
              >
                <Select
                  options={[
                    {
                      label: "Bút máy",
                      value: "Bút máy",
                    },
                  ]}
                />
              </Form.Item>
            </Col>

            <Col span={8}>
              <StyledTitle level={5}>
                ĐVT <span className="text-danger">(*)</span>
              </StyledTitle>
              <Form.Item
                name={eContent.Dram}
                rules={[{ required: true, message: "Nhập ĐVT" }]}
              >
                <Select
                  options={[
                    {
                      value: "Cái",
                      label: "Cái",
                    },
                  ]}
                />
              </Form.Item>
            </Col>

            <Col span={8}>
              <StyledTitle level={5}>
                Số lượng đề nghị <span className="text-danger">(*)</span>
              </StyledTitle>
              <Form.Item
                name={eContent.requestedQuantity}
                rules={[
                  { required: true, message: "Nhập Số lượng đề nghị" },
                  {
                    message: "Giá trị không hợp lệ",
                    pattern: new RegExp(/^[1-9][0-9]*$/),
                  },
                ]}
              >
                <InputNumber min={1} style={{ width: "100%" }} />
              </Form.Item>
            </Col>

            <Col span={8}>
              <StyledTitle level={5}>
                Số lượng tồn tại đơn vị <span className="text-danger">(*)</span>
              </StyledTitle>
              <Form.Item
                name={eContent.inventoryQuantity}
                rules={[
                  {
                    required: true,
                    message: "Nhập Số lượng tồn tại đơn vị",
                  },
                  {
                    message: "Giá trị không hợp lệ",
                    pattern: new RegExp(/^[1-9][0-9]*$/),
                  },
                ]}
              >
                <InputNumber min={1} style={{ width: "100%" }} />
              </Form.Item>
            </Col>

            <Col span={8}>
              <StyledTitle level={5}>
                Thời gian sử dụng <span className="text-danger">(*)</span>
              </StyledTitle>
              <Form.Item
                name={eContent.productLifetime}
                rules={[{ required: true, message: "Nhập thời gian sử dụng" }]}
              >
                <DatePicker style={{ width: "100%" }} />
              </Form.Item>
            </Col>

            <Col span={16}>
              <StyledTitle level={5}>Ghi chú</StyledTitle>
              <Form.Item name={eContent.note}>
                <Input />
              </Form.Item>
            </Col>

            <Col span={24}>
              <div className="flex-center">
                <StyledButton
                  bgColor="yellow"
                  type="primary"
                  htmlType="submit"
                  onClick={handleOk}
                >
                  Xác nhận
                </StyledButton>
              </div>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
};
